import { render, staticRenderFns } from "./ProjectsSlider.vue?vue&type=template&id=171d6e34&scoped=true&"
import script from "./ProjectsSlider.vue?vue&type=script&lang=js&"
export * from "./ProjectsSlider.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsSlider.vue?vue&type=style&index=0&id=171d6e34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171d6e34",
  null
  
)

export default component.exports